// polyfill
import 'reflect-metadata'

// styles
import 'ress' // reset css
import '@/assets/styles/_custom-theme.scss'

// vue
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { store, storeInjectionKey } from './store'
import { alertPlugin } from '@/libs/alertPortal'
import errorNotifierPlugin from '@/plugins/errorNotifier'
import apolloPlugin from '@/plugins/apollo'

// refs. https://www.npmjs.com/package/vite-plugin-sentry
import 'virtual:vite-plugin-sentry/sentry-config'
import { setupSentry } from './sentry'

import { setupGtm } from './gtm'
import VueGtag from 'vue-gtag-next'
import { createHead } from '@unhead/vue'

const run = async () => {
  const app = createApp(App)
    .use(router)
    .use(store, storeInjectionKey)
    .use(createHead())
    .use(alertPlugin)
    .use(errorNotifierPlugin)
    .use(VueGtag, { property: { id: import.meta.env.VITE_GA_TRACKING_ID } })
    .use(apolloPlugin)

  setupGtm(app)
  setupSentry(app)

  await router.isReady()
  app.mount('#app')
}

void run()
